import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import ButtonType from "%/dynamic-component-editor/options/button-type";
import Icon from "%/dynamic-component-editor/options/icon";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import ButtonIconSize from "%/dynamic-component-editor/options/button-icon-size";
import IconGap from "%/dynamic-component-editor/options/icon-gap";
import TextAlignment from "%/dynamic-component-editor/options/text-alignment";
import TextOption from "%/dynamic-component-editor/options/text-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import LinkType from "%/dynamic-component-editor/options/link-type";
import HrefOption from "%/dynamic-component-editor/options/href-option";
import ButtonSize from "%/dynamic-component-editor/options/button-size";

export default class ButtonOptions extends BaseOptionsBundle {

  optionTitle = "Button";
  static optionClassName = "i-dynamic-button";
  inspectorToolGroup = "button";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.BUTTON_TOOL_SET,
  };

  constructor(values = {}, hideFromInspector = {}, customTitle = null) {
    super(values, [
      new ButtonType(undefined, hideFromInspector["button-type"] ?? false),
      new ButtonSize(undefined, hideFromInspector["button-size"] ?? false),
      new TextOption(undefined, hideFromInspector["text-option"] ?? false),
      new Icon(undefined, hideFromInspector["icon"] ?? false),
      new IconPosition(undefined, hideFromInspector["icon-position"] ?? false),
      new ButtonIconSize(undefined, hideFromInspector["button-icon-size"] ?? false),
      new IconGap(undefined, hideFromInspector["icon-gap"] ?? false),
      new TextAlignment(undefined, hideFromInspector["text-alignment"] ?? false),
      new LinkType(undefined, hideFromInspector["link-type"] ?? false),
      new HrefOption(undefined, hideFromInspector["href-option"] ?? false),
    ]);

    if (customTitle !== null) {
      this.optionTitle = customTitle;
    }
  }
}
